import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

export default function Image({ src, ...rest }) {
  // Handle the case where src might be the image data directly or needs to be processed
  const imageData = src?.gatsbyImageData ? getImage(src) : src;
  return <GatsbyImage image={imageData} {...rest} />;
}
